module.exports = __webpack_public_path__ + "media/stylesheets/images/staff/hero-mobile_5-cf9cb302b630b0884b904aa0dbc08186.png";